import React from 'react';
import { MapPin, Quote, Star } from 'lucide-react';
import { COVERAGE, TESTIMONIALS, INDUSTRIES } from '../mock';

export default function CoverageTestimonials() {
  return (
    <>
      <section id="coverage" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-12">
            <div>
              <span className="text-[#17A2C4] font-bold uppercase tracking-wider text-sm reveal">Coverage Area</span>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-[#4E4E50] mt-2 mb-4 reveal">Wherever you need us in the GTA</h2>
              <p className="text-gray-600 mb-6 reveal">We deliver across Toronto and the Greater Toronto Area. If you don&rsquo;t see your city listed, give us a call &mdash; chances are we cover it.</p>
              <div className="flex flex-wrap gap-2.5">
                {COVERAGE.map((c, i) => (
                  <span key={c} className="reveal inline-flex items-center gap-1.5 bg-[#f5f7f8] border border-gray-200 text-[#4E4E50] text-sm font-semibold px-3.5 py-2 rounded-full" data-delay={i * 35}>
                    <MapPin size={14} className="text-[#17A2C4]" /> {c}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <span className="text-[#17A2C4] font-bold uppercase tracking-wider text-sm reveal">Industries We Serve</span>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-[#4E4E50] mt-2 mb-4 reveal">Trusted across sectors</h2>
              <div className="grid sm:grid-cols-2 gap-3">
                {INDUSTRIES.map((ind, i) => (
                  <div key={ind} className="reveal flex items-center gap-3 bg-[#f5f7f8] rounded-lg px-4 py-4 border-l-4 border-[#17A2C4]" data-delay={i * 60}>
                    <span className="font-semibold text-[#4E4E50]">{ind}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#f5f7f8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center max-w-2xl mx-auto mb-12 reveal">
            <span className="text-[#17A2C4] font-bold uppercase tracking-wider text-sm">Testimonials</span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-[#4E4E50] mt-2">What our clients say</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {TESTIMONIALS.map((t, i) => (
              <div key={t.name} className="reveal bg-white rounded-xl p-7 shadow-sm border border-gray-100" data-delay={i * 100}>
                <Quote size={30} className="text-[#17A2C4]/30 mb-3" />
                <div className="flex gap-0.5 mb-3">
                  {[...Array(5)].map((_, k) => <Star key={k} size={16} className="fill-[#f5a623] text-[#f5a623]" />)}
                </div>
                <p className="text-gray-700 mb-5 leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
                <div>
                  <div className="font-extrabold text-[#4E4E50]">{t.name}</div>
                  <div className="text-sm text-gray-500">{t.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
